// extracted by mini-css-extract-plugin
export var statusTag = "styles-module--statusTag--6b8fa";
export var statusTag_draft = "styles-module--statusTag_draft--75c38";
export var statusTag_inReview = "styles-module--statusTag_inReview--c918f";
export var statusTag_modified = "styles-module--statusTag_modified--4a226";
export var statusTag_published = "styles-module--statusTag_published--edd8d";
export var statusTags = "styles-module--statusTags--25df5";